module.exports = __webpack_public_path__ + "static/media/drop_off_primary.0801f869.png";